import React from 'react';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const QuoteExpiredModal: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
}) => {
  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle="Quote Expired"
      position="right"
      primaryBtnTxt="Close"
      givenClass="QuoteExpiredModal"
      primaryBtnColor="BtnOrange"
      handleClose={() => togglePanelOpen(false)}
      handlePrimaryBtn={() => togglePanelOpen(false)}
      width={460}
    >
      <p>This quote has expired. Please enter your preferences to get another quote.</p>
    </PopupOrPanel>
  );
};
